import { Component, Input, Output, EventEmitter } from '@angular/core';
import { SelectableCategory } from '../../../models/categories/category.models';

@Component({
    selector: 'category-tree-item',
    template: require('./tree.item.html')
})
export class CategoryTreeItem {
    private _category: SelectableCategory;

    @Input()
    set category(category: SelectableCategory) {
        this._category = category;
    }

    get category() {
        return this._category;
    }

    @Output() selectedChanged = new EventEmitter<any>();

    toggleExpandNode() {
        this._category.isExpanded = !this._category.isExpanded;
    }

    onSelectedChanged() {
        this._category.children.forEach((child: SelectableCategory) => {
            child.isSelected = this._category.isSelected;
        });

        if (this._category.isSelected) {
            this._category.isExpanded = true;
        }

        this.selectedChanged.emit();
    }

    onUpdateSelected() {
        this.selectedChanged.emit();
    }
}


// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./Client/app/components/common/category.tree.view/tree.item.ts